/**
 * @generated SignedSource<<b90a86f7301dec2ab7c7ced91bcea13c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RepositoryPickerRepositoryLight$data = {
  readonly databaseId: number | null | undefined;
  readonly id: string;
  readonly isInOrganization: boolean;
  readonly name: string;
  readonly nameWithOwner: string;
  readonly owner: {
    readonly avatarUrl: string;
    readonly databaseId: number | null | undefined;
    readonly login: string;
  };
  readonly shortDescriptionHTML: string;
  readonly " $fragmentType": "RepositoryPickerRepositoryLight";
};
export type RepositoryPickerRepositoryLight$key = {
  readonly " $data"?: RepositoryPickerRepositoryLight$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryPickerRepositoryLight">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "RepositoryPickerRepositoryLight"
};

(node as any).hash = "b2d6d13ee33102375ddd7925d7215326";

export default node;
